module.exports = __webpack_public_path__ + "static/media/tr.f33a094a.svg";